<template>
    <div class="content content-aligned">
        <h1>Lær at lave et labyrintspil</h1>
        <p>Følg vejledningerne i disse tre videoer, hvor du vil lære at lave dit eget labyrintspil.</p>
        <p>Hav en fane åben med videoerne og en anden fane med Scratch/CodingLab, hvor du koder dit spil.</p>
        <p>Sæt videoerne på pause undervejs, imens du koder.</p>

        <div class="content--centered">


            <EmbedYoutube class="video-tut-embed" id="ozmm84_nQl8" title="Step 1" />
            <EmbedYoutube class="video-tut-embed" id="FAZ58gqiA0s" title="Step 2" />
            <EmbedYoutube class="video-tut-embed" id="KCGGlvr_A1w" title="Step 3" />
            <EmbedYoutube class="video-tut-embed" id="O_LDJgNglOs" title="Step 4" />
        </div>
    </div>
</template>

<script>
import EmbedYoutube from "@/components/YoutubeEmbed";

export default {
    name: "VideoTutLabyrint",
    components: {
        EmbedYoutube
    },
};
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/pages/video-tutorials/video-tut-labyrint.vue